import {
    parseBliPermissionsFromSession,
    buildBliSidebarOptionsFromCatalog,
} from '../../../config/bliPermissionsRuntime';

/**
 * Menú lateral: solo catálogo BLI desde GET /users/bli-permissions (sessionStorage).
 * No usar configRolesUsers / pagesConfig para ítems del sidebar.
 */
const Options = () => {
    const parsed = parseBliPermissionsFromSession();
    if (!parsed || !Array.isArray(parsed.modules)) {
        return [];
    }
    return buildBliSidebarOptionsFromCatalog(parsed);
};

export default Options;
